import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getFullName } from '@/utils';
import { useGetParentQuery } from '@/services/parent-api';
import Page from '@/components/page';
import PageTitle from '@/components/page-title';
import EditForm from './edit-form';

const ParentEditPage = () => {
  const navigate = useNavigate();
  const { parentId } = useParams();
  const { data, isLoading } = useGetParentQuery({ parentId }, { skip: !parentId });

  useEffect(() => {
    if (parentId && !isLoading && !data) {
      navigate('/parent');
    }
  }, [parentId, data, isLoading, navigate]);

  const title = parentId ? 'Edit' : 'New';

  return (
    <Page
      breadcrumb={[
        { path: '/parent', label: 'Parents' },
        data && {
          path: `/parent/${parentId}`,
          label: [getFullName(data.primary.name), getFullName(data.significantOther?.name)]
            .filter((s) => s)
            .join(' & '),
        },
        title,
      ]}
      size="xl"
      loading={parentId && !data}
    >
      <PageTitle label={`${title}' Parent`} />
      <EditForm parentData={data} />
    </Page>
  );
};

export default ParentEditPage;
